export default {
  "debug": false,
  "dsn": "8mM7HCn2nYzMOQPu3nrQdFz9Xaj"
}